import download from 'downloadjs';
import printJS from 'print-js';

export const processFile = ({type = 'download', data, contentType, filename = ''}) => {
  switch (type){
    case 'open':
      openFile(data, contentType);
      break
    case 'print':
      printFile(data, contentType);
      break
    default:
      downloadFile(data, filename, contentType);
      break
  }
}

const openFile = (data, contentType) => {
  const file = new Blob([data], { type: contentType });
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
}

const printFile = (data, contentType) => {
  const file = new Blob([data], { type: contentType });
  const fileURL = URL.createObjectURL(file);
  printJS(fileURL);
}

const downloadFile = (data, filename, contentType) => download(data, filename, contentType);
